"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductUpdateToJSON = exports.ProductUpdateFromJSONTyped = exports.ProductUpdateFromJSON = exports.instanceOfProductUpdate = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ProductUpdate interface.
 */
function instanceOfProductUpdate(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfProductUpdate = instanceOfProductUpdate;
function ProductUpdateFromJSON(json) {
    return ProductUpdateFromJSONTyped(json, false);
}
exports.ProductUpdateFromJSON = ProductUpdateFromJSON;
function ProductUpdateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'styleId': !(0, runtime_1.exists)(json, 'style_id') ? undefined : json['style_id'],
        'designCompositeId': !(0, runtime_1.exists)(json, 'design_composite_id') ? undefined : json['design_composite_id'],
        'enabled': !(0, runtime_1.exists)(json, 'enabled') ? undefined : json['enabled'],
    };
}
exports.ProductUpdateFromJSONTyped = ProductUpdateFromJSONTyped;
function ProductUpdateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'style_id': value.styleId,
        'design_composite_id': value.designCompositeId,
        'enabled': value.enabled,
    };
}
exports.ProductUpdateToJSON = ProductUpdateToJSON;
